 
<template>
 <div id="baidu-map" :style="style">
 
  <el-dialog title="水源详情" center :visible.sync="showInfo" :width="viewDlgWidth" :close-on-click-modal="false" :append-to-body="true"  :show-close="true">
    <el-card :body-style="{ padding: '0px' }" style="font-size: 20px;">
      <img v-if="waterForm.waterUrl" :src="waterForm.waterUrl" class="image" style="height: 350px;width: 100%;">
      <div style="padding: 14px;">
        <div class="bottom clearfix">
          <time class="time">{{waterForm.waterSourceName}}{{waterForm.waterNum}}</time>
          <el-button type="text" class="button" v-if="waterForm.photoStatus == 1">
            <a :href="'https://dzxf.lanhaidata.com/output/'+waterForm.waterSourceId+'/output/photo.html'" target="_blank">查看全景图</a>
          </el-button>
        </div>
        <div class="bottom clearfix">
          <time class="time">地址：{{waterForm.location}}</time>
        </div>
        <div class="bottom clearfix">
          <time class="time">管辖人：{{waterForm.adminName}}</time>
        </div>
        <div class="bottom clearfix">
          <time class="time">状态：{{waterForm.statusName}}-{{waterForm.useName}}</time>
        </div>
        <div class="bottom clearfix">
          <time class="time">所属路段：{{waterForm.streetInfoName}}</time>
        </div>
        <div class="bottom clearfix">
          <time class="time">放置形式：{{waterForm.bfName}}</time>
        </div>
        <div class="bottom clearfix">
          <time class="time">所属管网：{{waterForm.gwName}}</time>
        </div>
        <div class="bottom clearfix">
          <time class="time">管网形状：{{waterForm.gwModeName}}</time>
        </div>
        <div class="bottom clearfix">
          <time class="time">接口形式：{{waterForm.qsName}}</time>
        </div>
        
      </div>
    </el-card>
  </el-dialog>
 </div>
</template>

<script>



import WaterSourceApi from '@/api/waterSource'
export default {


  
  data() { return {
    style: {
      width: '100%',
      height: this.height == 0 ? '100%' : this.height + 'px',
    },
    showInfo: false,
    waterForm: [],
    viewDlgWidth: '60%',
    mapvLayer: undefined,
    drawingManager: undefined,
    map: undefined,
    geo: undefined,
    overlay: undefined,
    tmpOverlays: [],
    defaultCursor: undefined,
    icon: undefined,
    unitIcons: undefined,
    cursorIcon: undefined,
    cursorMarker: undefined,
    mousemoveHandle: undefined,
    clickHandle: undefined,
  }},
  waterForm: [],
  props: {
    height: {
      type: Number,
      default: 0
    },
    scale: {
      type: Number,
      default: 11
    },
    longitude: Number,
    latitude: Number,
    flag: Object,
    city: String,
  },
  mounted() {
    const t = this
    var map = new BMap.Map("baidu-map", {enableMapClick: false})
    t.map = map
    t.defaultCursor = map.getDefaultCursor()
    t.geo = new BMap.Geocoder()
    t.icon = new BMap.Icon(require('@/img/hy-23x32.png'), new BMap.Size(23, 32), {anchor: new BMap.Size(13, 32)})
    t.unitIcons = [
      new BMap.Icon(require('@/img/xf-32x32.png'), new BMap.Size(32, 32), {anchor: new BMap.Size(16, 32)}),
      new BMap.Icon(require('@/img/zf-32x32.png'), new BMap.Size(32, 32), {anchor: new BMap.Size(16, 32)}),
      new BMap.Icon(require('@/img/xz-32x32.png'), new BMap.Size(32, 32), {anchor: new BMap.Size(16, 32)}),
      new BMap.Icon(require('@/img/qe-32x32.png'), new BMap.Size(32, 32), {anchor: new BMap.Size(16, 32)}),
      new BMap.Icon(require('@/img/wz-32x32.png'), new BMap.Size(32, 32), {anchor: new BMap.Size(16, 32)}),
      //new BMap.Icon(require('@/img/yg-32x32.png'), new BMap.Size(32, 32), {anchor: new BMap.Size(16, 32)}),
    ]
    t.waterSourceIcons = [
      new BMap.Icon(require('@/img/sn.png'), new BMap.Size(32, 32), {anchor: new BMap.Size(16, 32)}),
      new BMap.Icon(require('@/img/sw.png'), new BMap.Size(32, 32), {anchor: new BMap.Size(16, 32)}),
      //new BMap.Icon(require('@/img/yg-32x32.png'), new BMap.Size(32, 32), {anchor: new BMap.Size(16, 32)}),
    ]
    map.centerAndZoom(new BMap.Point(109.613302,19.521307), 16);
    // var point = new BMap.Point(t.longitude, t.latitude)
  
    // if (t.flag) {
    //   //t.setOverlay(t.flag)
    // } else {
     
    //   map.centerAndZoom(point, t.scale)
    // }
    map.setMapType(BMAP_HYBRID_MAP); 
    map.enableScrollWheelZoom(true)
    map.addControl(new BMap.NavigationControl({anchor: BMAP_ANCHOR_TOP_LEFT}));
    t.cursorIcon = new BMap.Icon(require('@/img/us-mk-icon.png'), new BMap.Size(21, 21), {anchor: new BMap.Size(6, 21)})
    t.cursorMarker = new BMap.Marker(map.getCenter())
    t.cursorMarker.setIcon(t.cursorIcon);
    map.addOverlay(t.cursorMarker)
    t.cursorMarker.setZIndex(1000)
    t.cursorMarker.hide()
    t.mousemoveHandle = evt => {
      t.cursorMarker.setPosition(evt.point)
      t.cursorMarker.show()
    }
  
    t.clickHandle = evt => { t.overlay.setPosition(evt.point) }
    map.addEventListener('click', evt => { console.log("point = ", evt.point) }) // todo DEBUG
    map.addEventListener("moveend", t.queryInRect());  
          
    map.addEventListener("zoomend", t.queryInRect()); 
  },
  watch: {
    flag: function(isLocation) {
      this.setOverlay(isLocation)
    },
  },
  methods: {
    qqMapToBMap(lng, lat) {
        
        // 首先确保坐标是GCJ-02(腾讯、高德使用)
        // 然后转换为BD-09(百度使用)
        const x_pi = 3.14159265358979324 * 3000.0 / 180.0;
        const x = lng;
        const y = lat;
        const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
        const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
        const bd_lng = z * Math.cos(theta) + 0.0065;
        const bd_lat = z * Math.sin(theta) + 0.006;
        return [bd_lng,bd_lat];
    
     },
    drawFences(fences) {
      const t = this
      if(!fences) return
      var fence = {}
      var unitIdList = []
      var unitNameList = []
      var iFenceXList = []
      var iFenceYList = []
      var fenceXList = []
      var fenceYList = []
      for(var i = 0; i < fences.length; i++){
        var fenceI = fences[i]
        if(i == 0) {
          fence = fenceI
          unitIdList.push(fenceI.unitId)
          unitNameList.push(fenceI.unitName)
        }else {
          if(fence.unitId != fenceI.unitId) {
            //下一个单位，应更换
            fenceXList.push(iFenceXList)
            fenceYList.push(iFenceYList)
            fence = fenceI
            unitIdList.push(fenceI.unitId)
            unitNameList.push(fenceI.unitName)
            iFenceXList = []
            iFenceYList = []
          }
          if(i == (fences.length-1)) {
            //最后一个
            iFenceXList.push(fenceI.unitGpsX)
            iFenceYList.push(fenceI.unitGpsY)
            fenceXList.push(iFenceXList)
            fenceYList.push(iFenceYList)
            break
          }
        }
        iFenceXList.push(fenceI.unitGpsX)
        iFenceYList.push(fenceI.unitGpsY)
      }

      
      //绘制
      for(let i=0;i<unitIdList.length;i++) {
        var unitId =  unitIdList[i]
        var unitName =  unitNameList[i]
        var fenceX =  fenceXList[i]
        var fenceY =  fenceYList[i]
        var fencePoints = []
        for(let j=0;j<fenceX.length;j++) {
          var x = fenceX[j]
          var y = fenceY[j]
          var pt = new BMap.Point(x, y)
          fencePoints.push(pt)
        }
        t.drawPolygon(unitId,unitName,fencePoints)
      }

    },
    drawPolygon(unitId,unitName,points) {
      const t = this
      let centerLat = 0.0
      let centerLng = 0.0
      for(let point of points) {
        centerLat += point.lat
        centerLng += point.lng
      }
      centerLat /= points.length
      centerLng /= points.length
      let centerPoi = new BMap.Point(centerLng,centerLat)
      let centerMarker = new BMap.Marker(centerPoi)
      const label = new BMap.Label(unitName,{offset:new BMap.Size(32, -20)})
      centerMarker.setIcon(t.unitIcons[4])
      centerMarker.setLabel(label)
      t.map.addOverlay(centerMarker)
      var styleOptions = {
        strokeColor: "black",    //边线颜色。
        fillColor: "red",      //填充颜色。当参数为空时，圆形将没有填充效果。
        strokeWeight: 2,       //边线的宽度，以像素为单位。
        strokeOpacity: 0.4,	   //边线透明度，取值范围0 - 1。
        fillOpacity: 0.4,      //填充的透明度，取值范围0 - 1。
        strokeStyle: 'solid' //边线的样式，solid或dashed。
    }
      // if (!t.overlay) return
      var polygon = new BMap.Polygon(
        points, styleOptions); 
      t.map.addOverlay(polygon)
      
     
    },
    clearFence(unitId) {
      const t = this
      const map = t.map
      const drawingManager = t.drawingManager
      map.removeControl(drawingManager._drawingTool)
      
      drawingManager.close();
    },
    drawFence(unitId) {
      const t = this
      const map = t.map
      var styleOptions = {
        strokeColor: '#5E87DB',   // 边线颜色
        fillColor: '#5E87DB',     // 填充颜色。当参数为空时，圆形没有填充颜色
        strokeWeight: 2,          // 边线宽度，以像素为单位
        strokeOpacity: 1,         // 边线透明度，取值范围0-1
        fillOpacity: 0.2          // 填充透明度，取值范围0-1
        };
        var labelOptions = {
            borderRadius: '2px',
            background: '#FFFBCC',
            border: '1px solid #E1E1E1',
            color: '#703A04',
            fontSize: '12px',
            letterSpacing: '0',
            padding: '5px'
      };
       // 实例化鼠标绘制工具
       var drawingManager = new BMapLib.DrawingManager(map, {isOpen: true, 
          drawingType: BMAP_DRAWING_MARKER, enableDrawingTool: true,
          enableCalculate: false,
          drawingToolOptions: {
              anchor: BMAP_ANCHOR_TOP_LEFT,
              offset: new BMap.Size(5, 5),
              drawingModes : [
                  BMAP_DRAWING_POLYGON
              ]
          },
        polygonOptions: styleOptions,    // 多边形的样式
         
      });
      var drawingType = BMAP_DRAWING_POLYGON;  
      t.drawingManager = drawingManager
      drawingManager.addEventListener("polygoncomplete", function(e) {
          //保存绘制的所有坐标点到后台
          t.$confirm('是否保存当前绘制数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var path = e.getPath();
            t.$emit('add-fence', path)
            t.$emit('on-fence', '')
            map.removeControl(drawingManager._drawingTool)
          }).catch(() => {
          });
          
          map.removeOverlay(e);
      });
      if (drawingManager._isOpen && drawingManager.getDrawingMode() === drawingType) {
            console.log('关闭...')
            drawingManager.close();
        } else {
            drawingManager.setDrawingMode(drawingType);
            drawingManager.open();
        }
    },
    queryInRect (event) {  
   
    
    },
    async setOverlay(alert) {
     
      const t = this
      const map = t.map
      if (t.overlay) map.removeOverlay(t.overlay)
      for (let v of t.tmpOverlays) map.removeOverlay(v)
      //map.clearOverlays()
      t.overlay = undefined
      t.tmpOverlays = []
      
      let pt
     
      if (!alert.longitude || !alert.latitude) {
       
        try {
          pt = await t.decodeAddress(alert.location)
          t.$emit('on-location', pt.lng, pt.lat)
        } catch (e) {
          pt = new BMap.Point(114.412326, 27.825875)
        }
      } else {
        
        pt = new BMap.Point(alert.longitude, alert.latitude)
      }
      const marker = new BMap.Marker(pt)
     
      marker.setIcon(t.icon)
     console.log(marker)
      map.addOverlay(marker)
      marker.setAnimation(BMAP_ANIMATION_BOUNCE);
      let content = `<div style='font-size: 13px'><b>时间：</b>${alert.alertTime}<br/>`
        + `<b>地址：</b>${alert.alertAddress}<br/></div>`

      var  infoWindow = new BMap.InfoWindow(content)
  
      marker.addEventListener('click', () => { marker.openInfoWindow(infoWindow) })
   
      
      if (t.overlay) map.panTo(pt)
      else map.centerAndZoom(pt, t.scale)

      t.overlay = marker
    },
    changeLocation(isLocation) {
      const t = this
      if (t.tmpOverlays.length) {
        for (const v of t.tmpOverlays) t.map.removeOverlay(v)
        t.tmpOverlays = []
      }
      if (isLocation) {
        console.log(t)
        // t.map.setDefaultCursor("Crosshair")
        t.overlay.setAnimation(null)
        t.overlay.enableDragging();  
        t.map.addEventListener('mousemove', t.mousemoveHandle)
        t.map.addEventListener('click', t.clickHandle);
      } else {
        // t.map.setDefaultCursor(t.defaultCursor)
        t.overlay.setAnimation(BMAP_ANIMATION_BOUNCE)
        t.overlay.disableDragging() 
        
        const pt = t.overlay.getPosition()
        if (pt.lng != t.flag.longitude || pt.lat != t.flag.latitude)
          t.$emit('on-location', pt.lng, pt.lat)
        t.map.removeEventListener('click', t.clickHandle)
        t.map.removeEventListener('mousemove', t.mousemoveHandle)
        t.cursorMarker.hide()
      }
    },
    async decodeAddress(addr) {
      const t = this
      return new Promise((resolve, reject) => {
        this.geo.getPoint(addr, pt => {
          pt && resolve(pt) || reject('找不到地址' + addr)
        }, t.city)
      })
    },
    drawCicle(radius, units, users) { // radius是米为单位
      const t = this
      if (!t.overlay) return
      if (t.tmpOverlays.length) {
        for (const v of t.tmpOverlays) t.map.removeOverlay(v)
        t.tmpOverlays = []
      }
      
      const cicle = new BMap.Circle(t.overlay.getPosition(), radius,
        {strokeColor:"red", strokeWeight:2, strokeOpacity:0.5, fillColor: "#FF9E80", fillOpacity: 0.5}); //创建圆
      t.map.addOverlay(cicle)
      t.tmpOverlays.push(cicle)

      /* 
      for (const unit of units) {
        const marker = new BMap.Marker(new BMap.Point(unit.unitGpsX, unit.unitGpsY))
        const label = new BMap.Label(unit.unitName,{offset:new BMap.Size(20, -10)})
        marker.setLabel(label)
        t.map.addOverlay(marker)
        t.tmpOverlays.push(marker)
      }
      */

      for (const user of users) {
        const marker = new BMap.Marker(new BMap.Point(user.userGpsX, user.userGpsY))
        const label = new BMap.Label(user.userName,{offset:new BMap.Size(20, -10)})
        marker.setLabel(label)
        t.map.addOverlay(marker)
        t.tmpOverlays.push(marker)
      }
    },
    markWaters(waters) {
      var that = this
      var data = [];
      for(let i=0;i<waters.length;i++) {
          var water = waters[i]
          var locationInfo =  [water.longitude, water.latitude]
          // if(water.waterSourceStatus && water.waterSourceStatus == 1) {
             
          // }else {
          //    img.src = '/img/hy-23x32.png'
          // }
          var red = '#D81E06'
          var green = '#1AFA29'
          var blue = '#13227A'
          var orange = '#D4237A'
          var pink = '#FF7F50'
          var black = '#2C2C2C'
          var blue2 = '#0086F1'
          var yellow = '#FFD32F'
          var zise = '#FF00FF'
          var selectColor = ''
          if(water.waterSourceType == 0){
                    if(water.waterSourceStatus == 0) {
                      if(water.adminUnitId == 21) {
                      selectColor = zise
                      }else if(water.adminUnitId == 22) {
                      selectColor = blue
                      }else if(water.adminUnitId == 23) {
                      selectColor = green
                      }else if(water.adminUnitId == 25) {
                      selectColor = black
                      }else if(water.adminUnitId == 29) {
                      selectColor = pink
                      }else {
                      selectColor = red
                      }
                    }else{
                      //故障
                      if(water.adminUnitId == 21) {
                      selectColor = '#FF99FF'
                      }else if(water.adminUnitId == 22) {
                      selectColor = '#CCFF00'
                      }else if(water.adminUnitId == 23) {
                      selectColor = '#9ACD32'
                      }else if(water.adminUnitId == 25) {
                      selectColor = '#B38B00'
                      }else if(water.adminUnitId == 29) {
                      selectColor = '#FFC145'
                      }else {
                      selectColor = yellow
                      }
                    }
                  }else {
                      selectColor = blue2
                  }
          data.push({
                  geometry: {
                      type: 'Point',
                      coordinates: [locationInfo[0], locationInfo[1]]
                  },
                  fillStyle: selectColor, 
                  count: water.location,waterSourceId: water.waterSourceId
          });
        }
        var options = {
              methods: {
                  click: function (item) {
                    console.log(item)
                    if(item) {
                      that.waterForm = []
                      WaterSourceApi.getById(item.waterSourceId).then(res=>{
                      that.waterForm = res.data
                        
                      that.showInfo= true
                      })
                    }
                  }
              },
              size: 8,
              shape: 'circle',
              opacity: 0.8
          }
        var dataSet = new mapv.DataSet(data);
        var mapvLayer = new mapv.baiduMapLayer(that.map, dataSet, options);
        that.mapvLayer = mapvLayer
   },
   clearWaterMap() {
      var that = this
      if(that.mapvLayer) {
        that.mapvLayer.destroy();
      }else {
        this.$message.error("水源数据尚未加载")
      }

   },
    waterImgShowOrHide(showImg) {
      var t = this
      if(t.mapvLayer) {
        if(showImg) {
          t.mapvLayer.show(); // 显示图层
        }else {
          
          t.mapvLayer.hide(); // 删除图层
        }
      }else{
        this.$message.error("水源数据尚未加载")
      }
    },
    markUnits(units) {
      for (const unit of units) {
        const marker = new BMap.Marker(new BMap.Point(unit.unitGpsX, unit.unitGpsY))
        if (unit.unitType != 0)
          marker.setIcon(this.unitIcons[unit.unitType - 1])
        const label = new BMap.Label(unit.unitName,{offset:new BMap.Size(32, -20)})
        marker.setLabel(label)
        label.addEventListener("click", function(){  
          alert(unit.unitName);  
      });
        this.map.addOverlay(marker)
      //   var map = new BMap.Map("baidu-map");
      //   var point = new BMap.Point(unit.UNIT_GPS_X,unit.UNIT_GPS_Y);
      //   map.centerAndZoom(point, 15);
        
      //   var opts = {
      //     position : point,    // 指定文本标注所在的地理位置
      //     offset   : new BMap.Size(30, -30)    //设置文本偏移量
      //   }
      //   var label = new BMap.Label(unit.unitName, opts);  // 创建文本标注对象
      //   label.setStyle({
      //     color : 'red',
      //     fontSize : '12px',
      //     height : '20px',
      //     lineHeight : '20px',
      //     fontFamily: '微软雅黑'
      //   });
      //   label.addEventListener("click", function(){  
      //     alert("您点击了标注");  
      // });
      //   map.addOverlay(label);   
        // if(unit.unitType==5){
        //   marker.setAnimation(BMAP_ANIMATION_BOUNCE);//跳动的动画
        // }
      // if(unit.unitType==3){
      //   let content = `<input type='button' id='btn' value='预案'/>
      //                     <input type='button'  id='btn1' value='360全景图'/>
      //                     <input type='button' onclick='alert("还未开放")' id='btn2' value='3D实景'/>`
            
            
      //       var  infoWindow = new BMap.InfoWindow(content)
      //         marker.addEventListener("click", function() {
      //             this.openInfoWindow(infoWindow);
      //             this.openInfoWindow(infoWindow);
      //             //图片加载完毕重绘infowindow
      //             document.getElementById("btn").onclick = function() {
                
      //             window.open('http://data.lanhaidata.com:8089/dsj/yuan.jsp', '_blank', 'toolbar=yes, width=1000, height=900')
      //             }
      //             document.getElementById("btn1").onclick = function() {
                
      //             window.open('http://data.lanhaidata.com:8089/dsj/output/1.html', '_blank', 'toolbar=yes, width=672, height=572')
      //             }
      //   });
      // }
      
      // marker.addEventListener('click', () => { marker.openInfoWindow(infoWindow) })
      }
    },
 
    panTo(x, y) {
      var locationInfo =  this.qqMapToBMap(x,y)
      this.map.panTo(new BMap.Point(locationInfo[0], locationInfo[1]))
    },
    buildMarker(x, y, text) {
      const marker = new BMap.Marker(new BMap.Point(x, y))
      const label = new BMap.Label(text)
      marker.setLabel(label)
      this.map.addOverlay(marker)
      this.tmpOverlays.push(marker)
    },
   
  },
  
  
}



</script>





// WEBPACK FOOTER //
// src/components/map.vue